export class User {
    Id: string;
    FirstName: string;
    LastName: string;
    PicturePath: string;
    PhoneNumber: string;
    Address;
    City: string;
    State: string;
    Zip: string;
    RoleId: string[];
    RolesArray: [];
    SessionTime: string;
    DontShowNda: NdaStatus;
}

export enum IdentitySource{
    'ActiveDirectory' = 0,
    'LocalUser' = 1
}

export enum NdaStatus{
    'NotSigned' = 0,
    'Signed' = 1,
    'SignedDontShowAgain' = 2
}

export class ChangeNdaStatusViewModel
{
    UserId: string;
    NdaStatus: NdaStatus
}

export class ConfirmWithCodeViewModel
{
    Email: string;
    EmailCode: string;
    PhoneNumber: string;
    PhoneCode: string;
}